import { CountedState } from "./Enums/CountedState";
import WorkerData from "./WorkerData";
import WorkPeriod from "./WorkPeriod";

export default class WorkDay {
    public Id: string;
    public Date: string;
    public TipPin: number;
    public TipCash: number;
    public IsClosed: boolean;
    public CountedState: CountedState;
    public CountedBy: string[];
    public Workers: WorkerData[];
    public WorkPeriods: WorkPeriod[];

    constructor(id: string, date: string, tipPin: number, tipCash: number, isClosed: boolean, countedState: CountedState, countedBy: string[], workers: WorkerData[], workPeriods: WorkPeriod[] = []) {
        this.Id = id;
        this.Date = date;
        this.TipPin = tipPin;
        this.TipCash = tipCash;
        this.IsClosed = isClosed;
        this.CountedState = countedState;
        this.CountedBy = countedBy;
        this.Workers = workers;
        this.WorkPeriods = workPeriods;
    }
}
